

















import { Component, Vue, Prop } from 'vue-property-decorator';
import IdDocType from '@/resources/enum/IdDocType';

@Component
export default class DiagonalHeader extends Vue {
  private get top(): number {
    return this.$store.state.camera.headerMarginHeight + 24;
  }

  private get isIdDocPassport(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.PassportHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTi) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTi) return true;
    return false;
  }

  private get isIdDocHealthInsuranceCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.HealthInsuranceCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.HealthInsuranceCardTi) return true;
    return false;
  }

  private get isGeneralCard(): boolean {
    return this.$store.getters['camera/isGeneralCard'];
  }

  private get sentences(): string[] {
    if (this.isIdDocPassport) {
      return [
        'cameraCameraChildShooting.thickness.from',
        'cameraCameraChildShooting.thickness.target1',
        'cameraCameraChildShooting.thickness.and',
        'cameraCameraChildShooting.thickness.target2'
      ];
    } else if (this.isIdDocHealthInsuranceCard) {
      return [
        'cameraCameraChildShooting.diagonalNoFace.from',
        'cameraCameraChildShooting.diagonalNoFace.target1',
        'cameraCameraChildShooting.diagonalNoFace.and',
        'cameraCameraChildShooting.diagonalNoFace.target2'
      ];
    } else if (this.isGeneralCard) {
      return [
        'cameraCameraChildShooting.diagonalGeneralCard.from',
        'cameraCameraChildShooting.diagonalGeneralCard.target1',
        'cameraCameraChildShooting.diagonalGeneralCard.and',
        'cameraCameraChildShooting.diagonalGeneralCard.target2'
      ];
    } else {
      return [
        'cameraCameraChildShooting.diagonal.from',
        'cameraCameraChildShooting.diagonal.target1',
        'cameraCameraChildShooting.diagonal.and',
        'cameraCameraChildShooting.diagonal.target2'
      ];
    }
  }
}
